import { Injectable } from "@angular/core";
import { ActivatedRouteSnapshot, RouterStateSnapshot } from "@angular/router";
import { catchError, Observable, of, tap } from "rxjs";
import { NavigationService } from "app/core/navigation/navigation.service";

@Injectable({
  providedIn: "root",
})
export class InitialDataResolver {
  /**
   * Constructor
   */
  constructor(private _navigationService: NavigationService) {}

  // -----------------------------------------------------------------------------------------------------
  // @ Public methods
  // -----------------------------------------------------------------------------------------------------

  /**
   * Use this resolver to resolve initial mock-api for the application
   *
   * @param route
   * @param state
   */
  resolve(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<any> {
    console.log("InitialDataResolver: Starting resolution");
    return this._navigationService.get().pipe(
      tap(() =>
        console.log("InitialDataResolver: NavigationService.get completed")
      ),
      catchError((err) => {
        console.error("InitialDataResolver: NavigationService.get failed", err);
        return of(null);
      })
    );
  }
}
